<div class="w-full mx-auto mt-6">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="text-center text-gray-500 py-8">Loading FAQs...</div>

  <!-- Error State -->
  <div *ngIf="error" class="text-center text-red-500 py-8">{{ error }}</div>

  <!-- FAQs List -->
  <div *ngIf="!isLoading && !error">
    <div *ngFor="let faq of faqs; let i = index" class="border-b border-gray-200 dark:border-gray-700">
      <button
        class="w-full flex justify-between items-center py-4 text-left focus:outline-none"
        (click)="toggle(i)">
        <span class="font-medium text-gray-900 dark:text-white">{{ faq.question }}</span>
        <span
          class="material-symbols-outlined transition-transform duration-300"
          [ngClass]="{'rotate-180': faq.open}">
          expand_more
        </span>
      </button>
      <div *ngIf="faq.open" class="pb-4 text-gray-700 dark:text-gray-300">
        {{ faq.answer }}
      </div>
    </div>
  </div>
</div>
